module.exports = __webpack_public_path__ + "img/sz.4a55fcad.png";